import axios from 'axios'

import ApiResponse, { isApiResponseWrapped } from '@/models/Common/ApiResponse'
import { isProduction } from '@/utils/dev'

let defaultAPIUrl = ''

export const initApiUrl = (url) => {
  defaultAPIUrl = url
}

const http = axios.create({
  baseURL: process.env.VUE_APP_PROXY_API_URL
})

const commonLogic = async (type, { url, data, config }) => {
  let target = () => {}
  const apiUrl = `${defaultAPIUrl}${url}`

  try {
    if (type !== 'get' && type !== 'delete') {
      target = await http[type](apiUrl, data, config)
    } else {
      target = await http[type](apiUrl, config)
    }
  } catch (error) {
    const responseData = error.response.data
    const apiResponseWrapped = isApiResponseWrapped(responseData)

    return ApiResponse.fail({
      success: false,
      code: apiResponseWrapped ? responseData.code : responseData.status,
      errorCode: responseData.errorCode,
      message: apiResponseWrapped
        ? responseData.message || (isProduction() ? undefined : responseData.result)
        : undefined // ApiResponse wrapping 안됐을 때 에러메시지 버림
    })
  }

  const responseData = target.data
  const apiResponseWrapped = isApiResponseWrapped(responseData)

  if (parseInt(responseData.code, 10) > 400) {
    return ApiResponse.fail({
      success: false,
      code: apiResponseWrapped ? responseData.code : responseData.status,
      errorCode: responseData.errorCode,
      result: responseData.result,
      message: apiResponseWrapped
        ? responseData.message || (isProduction() ? undefined : responseData.result)
        : undefined // ApiResponse wrapping 안됐을 때 에러메시지 버림
    })
  }

  return apiResponseWrapped
    ? ApiResponse.ok(responseData)
    : ApiResponse.ok({ result: { ...responseData } })
}

const api = {
  get: async (url, config) => commonLogic('get', { url, config }),
  post: async (url, data, config) => commonLogic('post', { url, data, config }),
  patch: async (url, data, config) => commonLogic('patch', { url, data, config }),
  put: async (url, data, config) => commonLogic('put', { url, data, config }),
  delete: async (url, config) => commonLogic('delete', { url, config })
}

export default api
